import { useEffect } from "react";

import {
  buildTokensStats,
  getTokenRefreshTimeout,
  logAuthEvent,
  refreshAccessToken,
} from "../auth.helper";
import { useAuthContext } from "../auth.hook";

export const useAuthRefreshToken = () => {
  const { token, setToken } = useAuthContext();

  useEffect(() => {
    if (!token) {
      logAuthEvent("useAuthRefreshToken: NO TOKEN");
      return;
    }

    logAuthEvent("useAuthRefreshToken: TOKEN found");
    const timeoutDuration = getTokenRefreshTimeout(token);

    const timeoutID = setTimeout(() => {
      refreshAccessToken().then((tokens) => {
        logAuthEvent(
          "useAuthRefreshToken: TOKEN refresh process completed",
          buildTokensStats(tokens)
        );
        setToken(tokens?.accessToken);
      });
    }, timeoutDuration);

    return () => clearTimeout(timeoutID);
  }, [token]);
};
